"use client";

import { ServiceSliderSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedServiceSliderSection from "../Components/GeneratedServiceSliderSection";

const ServiceSlider: FC<ServiceSliderSectionProps> = (props) => {
  return <GeneratedServiceSliderSection {...props} />;
};

export default ServiceSlider;
